export default __webpack_public_path__ + "static/media/meetingpagevideo.217138d8.mp4";